var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5524 1.41762C55.8159 2.64111 55.8159 4.62479 54.5524 5.84828L26.7749 32.7471C22.9845 36.4176 16.8391 36.4176 13.0487 32.7471L1.4476 21.513C0.184135 20.2895 0.184135 18.3059 1.4476 17.0824C2.71106 15.8589 4.75953 15.8589 6.02299 17.0824L17.6241 28.3165C18.8875 29.54 20.936 29.54 22.1995 28.3165L49.977 1.41762C51.2405 0.194126 53.2889 0.194126 54.5524 1.41762Z",
    fill: "#4CA154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBold);
export default __webpack_public_path__ + "static/media/check-bold.e0b63997fb47463660df4a6e11c1777a.svg";
export { ForwardRef as ReactComponent };